<form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-4">
	<!-- Message de succès -->
	@if (success) {
	<div class="bg-green-50 border border-green-200 rounded-lg p-4">
		<div class="flex items-center">
			<div class="text-green-600 text-sm">Contact ajouté avec succès !</div>
		</div>
	</div>
	}

	<!-- Message d'erreur -->
	@if (error) {
	<div class="bg-red-50 border border-red-200 rounded-lg p-4">
		<div class="flex items-center">
			<div class="text-red-600 text-sm">{{ error }}</div>
		</div>
	</div>
	}

	<div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
		<div>
			<label class="text-sm required" for="firstName">Prénom</label>
			<input type="text" id="firstName" formControlName="firstName" required
				class="input placeholder:text-[12px] placeholder:text-slate-400 w-full" placeholder="Prénom">
			@if (getErrorMessage('firstName')) {
			<div class="text-red-500 text-xs mt-1">{{ getErrorMessage('firstName') }}</div>
			}
		</div>

		<div>
			<label class="text-sm required" for="lastName">Nom</label>
			<input type="text" id="lastName" formControlName="lastName" required
				class="input placeholder:text-[12px] placeholder:text-slate-400 w-full" placeholder="Nom">
			@if (getErrorMessage('lastName')) {
			<div class="text-red-500 text-xs mt-1">{{ getErrorMessage('lastName') }}</div>
			}
		</div>

		<div class="col-span-2">
			<label class="text-sm required" for="type">Type de contact</label>
			<select id="type" formControlName="type" required
				class="input placeholder:text-[12px] placeholder:text-slate-400 w-full">
				<option value="" disabled selected>Choisir le type</option>
				@for (option of contactTypes; track option) {
				<option [value]="option.value">{{ option.label }}</option>
				}
			</select>
			@if (getErrorMessage('type')) {
			<div class="text-red-500 text-xs mt-1">{{ getErrorMessage('type') }}</div>
			}
		</div>

		<div class="col-span-2">
			<label class="text-sm required" for="mobileNumber">Numéro mobile</label>
			<angular-phone-number-input id="mobileNumber" formControlName="mobileNumber" [defaultCountry]="'SN'"
				[border]="true" (ngModelChange)="onPhoneInputChange($event)" class="w-full !h-[40px]">
			</angular-phone-number-input>
			@if (getErrorMessage('mobileNumber')) {
			<div class="text-red-500 text-xs mt-1">{{ getErrorMessage('mobileNumber') }}</div>
			}
		</div>
	</div>

	<div class="flex justify-end space-x-3 pt-4">
		<button type="button" class="btn btn-outline" (click)="closeModal()" [disabled]="loading">
			Annuler
		</button>
		<button type="submit" class="btn btn-primary" [disabled]="!form.valid || loading">
			@if (loading) {
			<span class="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></span>
			}
			{{ loading ? 'Ajout en cours...' : 'Ajouter le contact' }}
		</button>
	</div>
</form>